import { Form, Input, message, Button, Tooltip, Divider, Popconfirm } from 'antd'
import React, { useEffect, useState } from 'react'
import { newUser } from '../../api/user'
import InputImage from '../inputImage'
import API from '../../api'
import { useSelector, useDispatch } from 'react-redux'
import { IState } from '../../reducers'
import { getShortDateStr, ObsKeyToURL } from '../../api/utils'
import UploadLogoCom from './uploadLogo'
import { newOrg } from 'api/org'
import { useHistory } from 'react-router-dom'
import { saveUser } from 'reducers/user'
import { RightOutlined } from '@ant-design/icons'

const UserInfo = () => {
  const [visible, setVisible] = useState(0)
  const [username, setUsername] = useState('')
  const [nickname, setNickname] = useState('')
  const [email, setEmail] = useState('')
  const [userForm] = Form.useForm()
  const [uploadLogoModal, setUploadLogoModal] = useState(false)
  const history = useHistory()
  const orgTypes = useSelector((state: IState) => state.org.modules)
  const user = useSelector((state: IState) => {
    return state.user
  })
  const dispatch = useDispatch()

  // 加载用户信息
  useEffect(() => {
    setNickname(user.nickname)
    setEmail(user.email)
    setUsername(user.username)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.user_id])

  //当头像修改成功后，重新设置sessionStorage的值
  useEffect(() => {
    if (user.image !== '' || user.org.image !== '') {
      dispatch(saveUser(user))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.image, user.org.image])

  //更新个人信息
  const updateUserInfo = () => {
    const newUser = {
      ...user,
    }
    switch (visible) {
      case 1:
        newUser.nickname = nickname
        break
      case 3:
        newUser.email = email
        break
      case 4:
        newUser.username = username
    }
    setVisible(0)
    if (
      newUser.nickname === user.nickname &&
      newUser.email === user.email &&
      newUser.username === user.username
    ) {
      message.info('用户信息未修改', 3)
      return
    }
    API.editUser(newUser).then(res => {
      if (res.code === 200) {
        dispatch(saveUser(newUser))
        message.success({
          content: '保存成功',
          className: 'message-success',
          duration: 3,
        })
      } else if (res.code === 1002) {
        message.warn({
          content: '重复的登录名',
          duration: 3,
        })
        setUsername(user.username)
      }
    })
  }

  const changeNickname = e => {
    setNickname(e.target.value)
  }

  const changeUsername = e => {
    setUsername(e.target.value)
  }

  //取消修改个人信息
  const handleCancel = () => {
    userForm.resetFields()
    switch (visible) {
      case 1:
        setNickname(user.nickname)
        break
      case 3:
        setEmail(user.email)
        break
      case 4:
        setUsername(user.username)
        break
    }

    setVisible(0)
  }

  //更新学校LOGO
  const updateSchoolLogo = (url: string) => {
    let org = newOrg()
    org.image = url
    org.org_id = user.org.org_id
    API.updateOrg(org).then(res => {
      if (res.code === 200) {
        let newUser = { ...user, org: { ...user.org, image: res.data.image } }
        dispatch(saveUser(newUser))
      }
    })
  }

  //更新个人头像
  const updateUserImage = (url: string) => {
    let nu = newUser()
    nu.user_id = user.user_id
    nu.image = url
    API.editUser(nu).then(res => {
      if (res.code === 200) {
        let newUser = { ...user, image: res.data.image }
        dispatch(saveUser(newUser))
      }
    })
  }

  //返回对应账号类型的描述
  const getRole = (type: string) => {
    switch (type) {
      case 'school':
        return '学校账号'
      case 'teacher':
        return '教师账号'
      case 'admin':
        return '管理员账号'
      case 'student':
        return '学生账号'
      default:
        return '游客账号'
    }
  }

  //打开上传学校logo的模态框
  const openUploadLogoModal = () => {
    setUploadLogoModal(true)
  }

  //复制文字内容
  const copyText = text => {
    const input = document.createElement('input')
    document.body.appendChild(input)
    input.value = text
    input.select()
    document.execCommand('copy', false)
    input.remove()
    message.success({
      content: '复制成功',
      duration: 2,
    })
  }
  return (
    <div className="user-info-group-outer">
      <div className="user-info-group">
        <div className="user-info-group-header second-title">账号信息</div>
        <div className="user-info-group-content">
          <div className="user-avatar">
            <InputImage keyPrefix="user/image/" initURL={user.image} setURL={updateUserImage} />
          </div>
          <div className="user-info-content">
            <Form
              name="user-form"
              onFinish={updateUserInfo}
              form={userForm}
              requiredMark={false}
              colon={false}
              labelAlign="left"
            >
              <Form.Item label="用户名" name="username" className="user-form-item">
                <div className="user-form-item-input-outer">
                  <Tooltip title="点击编辑">
                    <Input
                      bordered={visible === 4}
                      className={`user-form-item-input ${visible === 4 ? 'user-form-item-input-active' : ''
                        }`}
                      allowClear={visible === 4}
                      value={username}
                      onChange={changeUsername}
                      onClick={() => {
                        setVisible(4)
                        setNickname(user.nickname)
                        setEmail(user.email)
                      }}
                      suffix={<span />}
                    />
                  </Tooltip>
                  {visible === 4 ? (
                    <div className='user-form-item-buttons'>
                      <Button
                        className="user-form-item-button"
                        style={{ color: '#40a9ff' }}
                        onClick={updateUserInfo}
                      >
                        确认
                      </Button>
                      <Button
                        className="user-form-item-button"
                        style={{ color: '#bfbfbf' }}
                        onClick={handleCancel}
                      >
                        取消
                      </Button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </Form.Item>
              <Form.Item label="昵称" name="nickname" className="user-form-item">
                <div className="user-form-item-input-outer">
                  <Tooltip title="点击编辑">
                    <Input
                      bordered={visible === 1}
                      className={`user-form-item-input ${visible === 1 ? 'user-form-item-input-active' : ''
                        }`}
                      allowClear={visible === 1}
                      value={nickname}
                      onChange={changeNickname}
                      onClick={() => {
                        setVisible(1)
                        setEmail(user.email)
                        setUsername(user.username)
                      }}
                      suffix={<span />}
                    />
                  </Tooltip>
                  {visible === 1 ? (
                    <div className='user-form-item-buttons'>
                      <Button
                        className="user-form-item-button"
                        style={{ color: '#40a9ff' }}
                        onClick={updateUserInfo}
                      >
                        确认
                      </Button>
                      <Button
                        onClick={handleCancel}
                        className="user-form-item-button"
                        style={{ color: '#bfbfbf' }}
                      >
                        取消
                      </Button>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </Form.Item>
              <Form.Item label="密码" className="user-form-item">
                <Tooltip title="点击编辑">
                  <Popconfirm
                    title="确认修改当前密码?"
                    onConfirm={() => history.push('/user/edit_password')}
                  >
                    <div className="user-form-item-input user-form-item-password">********</div>
                  </Popconfirm>
                </Tooltip>
              </Form.Item>
              <Form.Item label="手机号码" className="user-form-item">
                <Tooltip title="点击编辑">
                  <Popconfirm
                    title="确认更换当前绑定的手机号?"
                    onConfirm={() => history.push('/user/bind_phone')}
                  >
                    <div className="user-form-item-input second-title user-form-item-phone">
                      {user.phone}
                    </div>
                  </Popconfirm>
                </Tooltip>
              </Form.Item>
              {/* <Form.Item
              className="user-form-item"
              label="绑定邮箱"
              name="email"
              rules={[
                {
                  required: false,
                  pattern: new RegExp(
                    /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/,
                    'g'
                  ),
                  message: '请输入正确的邮箱！',
                },
              ]}
            >
              <div className="user-form-item-input-outer">
                <Tooltip title="点击编辑">
                  <Input
                    bordered={visible === 3}
                    className={`user-form-item-input ${
                      visible === 3 ? 'user-form-item-input-active' : ''
                    }`}
                    allowClear={visible === 3}
                    onClick={() => {
                      setVisible(3)
                      setNickname(user.nickname)
                      setUsername(user.username)
                    }}
                    value={email}
                    onChange={changeEmail}
                    maxLength={50}
                    suffix={<span />}
                  />
                </Tooltip>
                {visible === 3 ? (
                  <div>
                    <Button
                      htmlType="submit"
                      className="user-form-item-button"
                      style={{color: '#40a9ff'}}
                    >
                      确认
                    </Button>
                    <Button
                      onClick={handleCancel}
                      className="user-form-item-button"
                      style={{color: '#bfbfbf'}}
                    >
                      取消
                    </Button>
                  </div>
                ) : (
                  <div></div>
                )}
              </div>
            </Form.Item> */}
              <Form.Item
                label="学校"
                className={`user-form-item ${user.type === 'guest' || user.type === 'admin' ? 'hide' : ''
                  }`}
              >
                <div className="form-item-control second-title">{user.org.name}</div>
              </Form.Item>
              <Form.Item
                label=" "
                className={`user-form-item ${user.type === 'school' ? '' : 'hide'}`}
              >
                <div className="school-logo-outer">
                  <img
                    src={
                      user.org.image !== '' && user.org.image !== undefined
                        ? ObsKeyToURL(user.org.image)
                        : `${process.env.PUBLIC_URL}/images/login-form-logo.png`
                    }
                    alt="logo"
                    className="school-logo"
                    onClick={openUploadLogoModal}
                  />
                </div>
              </Form.Item>
              <Form.Item label="账号角色" className="user-form-item">
                <div className="form-item-control second-title">{getRole(user.type)}</div>
              </Form.Item>
              <Form.Item
                label="有效期"
                className={`user-form-item`}
              >
                <div className="form-item-control second-title">
                  {/* TODO 后续修改 */}
                  {user.expiry ? getShortDateStr(user.expiry) : ''}
                </div>
              </Form.Item>
            </Form>
          </div>
        </div>
        <Divider className="user-info-divider" />
        <div className={`${user.type === 'guest' || user.type === 'student' ? 'hide' : ''
          }`}>
          <div className="second-title" style={{ color: '#262626' }}>
            课程资源
          </div>
          <div className="orgTypes-group">
            {orgTypes.map(item => (
              <div className="grade-title-group" style={{ marginRight: 16 }} key={item.id}>
                <img src={ObsKeyToURL(item.image)} alt="module" />
              </div>
            ))}
          </div>
        </div>
        <UploadLogoCom
          showLogoModal={uploadLogoModal}
          setShowLogoModal={setUploadLogoModal}
          initURL={user.org.image !== undefined && user.org.image !== '' ? user.org.image : ''}
          setURL={updateSchoolLogo}
        />
      </div>
      <div className="contact-details-card-outer">
        <div className="contact-details-card">
          <div className="contact-details-card-title">若需要提供付费或者续费服务，请联系我们。</div>
          <Tooltip
            title="点击可复制"
            placement="topRight"
            overlayClassName="contact-details-tooltip-card"
          >
            <div className="contact-details-card-item" onClick={() => copyText('0755-2691 8115')}>
              <img src={process.env.PUBLIC_URL + '/images/phone.png'} alt="phone-icon" />
              <span className="bold contact-details-card-item-text">0755-2691 8115</span>
              <RightOutlined className="contact-details-card-item-icon" />
            </div>
          </Tooltip>
          <Tooltip
            title="点击可复制"
            placement="topRight"
            overlayClassName="contact-details-tooltip-card"
          >
            <div
              className="contact-details-card-item"
              onClick={() => copyText('sales@glitech.com')}
            >
              <img src={process.env.PUBLIC_URL + '/images/email.png'} alt="email-icon" />
              <span className="bold contact-details-card-item-text">sales@glitech.com</span>
              <RightOutlined className="contact-details-card-item-icon" />
            </div>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

export default UserInfo
